import React from "react";
import { Redirect, Route, useLocation } from "react-router-dom";
import routes, { rerouteAfterLoginRoutes } from "../utils/routes";
import AuthService from "../utils/authService";

export const AuthenticatedRoute = ({ component: Component, ...rest }) => {
  const location = useLocation();
  let queryParams = "";
  try {
    queryParams = location.search;
  } catch (e) {
    //log it
  }

  if (
    !AuthService.isAuthenticated() &&
    rerouteAfterLoginRoutes.includes(location.pathname)
  ) {
    queryParams = "?redirect=" + location.pathname + queryParams;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        AuthService.isAuthenticated() ? (
          <Component {...props} {...rest} />
        ) : (
          <Redirect to={routes.LOGIN + queryParams} />
        )
      }
    />
  );
};
export default AuthenticatedRoute;
